export class IncomeEquityData{

  income: string;
  patrimony: string;
  noIncome: boolean;
  noPatrimony: boolean;
  pep: boolean;
  nif: string;
  taxResidence: string;
  taxResidenceName: string;
  personLinkedToTheBrokerage: boolean;
  accountOpeningTerms: string;
  purposeStatement: string;
  declarationCustomerNotAuthorizeAttorney: string;
  intermediationProposal: string;
  rulesAndParameters: string;
  accessConditions: string;
  customerStatements: string;
  dateTaxResidency: string;
  isCompleted?: boolean;
  editData: [];
  firstEdit? = [];
}
